module.exports = __webpack_public_path__ + "static/media/img_bg4@2x.da21846d.png";